/**
 * Identidad visual del landing público de un seminario, compartida por el
 * landing, la ruta de formación y la página de cada programa. Oscuro siempre:
 * el acento sale del color del seminario, apagado para el tono institucional.
 */
export const LANDING_FONT_LINK = `@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;1,400;1,500&family=Inter:wght@300;400;500;600&display=swap');`;

export const LANDING = {
  BG: '#0d0f0f',
  BG2: '#111315',
  RAISED: '#151818',
  BORDER: 'rgba(255,255,255,0.07)',
  RULE: 'rgba(232,228,220,0.10)',
  TEXT_PRIMARY: '#e8e4dc',
  TEXT_MUTED: '#7a756a',
  TEXT_SECONDARY: '#a09890',
  SERIF: "'Cormorant Garamond', Georgia, serif",
  SANS: "'Inter', system-ui, sans-serif",
  DEFAULT_COLOR: '#b08d57',
} as const;

function hex2rgba(hex: string, alpha: number): string {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r},${g},${b},${alpha})`;
}

export function colorToRgba(color: string, alpha: number): string {
  if (color.startsWith('#')) return hex2rgba(color, alpha);
  return color;
}

/** Desaturate + darken a hex color for muted/institutional feel. */
export function muteColor(hex: string): string {
  if (!hex.startsWith('#') || hex.length < 7) return hex;
  const r = Math.round(parseInt(hex.slice(1, 3), 16) * 0.82);
  const g = Math.round(parseInt(hex.slice(3, 5), 16) * 0.76);
  const b = Math.round(parseInt(hex.slice(5, 7), 16) * 0.58);
  return `rgb(${r},${g},${b})`;
}

/** El dorado del seminario: apagado para fondos y bordes, y su versión con alfa. */
export function landingGold(primaryColor: string | undefined) {
  const color = primaryColor || LANDING.DEFAULT_COLOR;
  return { GOLD: muteColor(color), GOLD_ALPHA: (a: number) => colorToRgba(color, a) };
}
